import Vue from 'vue'
import Vuex from 'vuex'
import $ from "jquery";

Vue.use(Vuex)

import service from '@/store/services.js'
import ebook from "@/config/Ebook.json";//Configuraciones del Ebook
import literal from "@/config/literal.json";//Idioma del Ebook

window.document.title = ebook.config.tituloEbook;

let idioma = literal[ebook.config.idioma];

// import zonasActivas from "@/config/ZonasActivas.json";//Zonas activas que tendra el Ebook
// import zonasActivas from "@/config/ZonasActivas.json";

export default new Vuex.Store({

  /**
   * Variables globales que seran accedido por todos los componentes
   */
  state: {
    ebook: ebook.ebook,//Obtiene el JSON del Ebook que se encuentra en la carpeta config
    config: ebook.config,
    recursosGlobales: ebook.recursos,
    literal: idioma,
    zonasActivas: service.localZone,
    service: service,

    isCrop: false,

    twoPages: ebook.config.esBinario,
    isMobile: false,
    typeModalResource: "",

    //MODALES
    modalCronograma: false,//Abre el modal de cronograma
    modalAudio: false,
    openCredits: false,
    openResourceFull: false,
    openResource: false,
    openAddResource: false,
    isModeActiveZone: false,
    modal: false,//Modal principal
    maxWidthModal: 1440, //El valor maximo del ancho que puede tener el modal
    openHZone: false,//Para identificar si las herramientas de zona activa estan abiertas
    selectArea: false,

    heightZona: 150,//Altura de los botones de la zona activ y, enlace
    widthZona: 150,//Ancho de los botones de la zona activa y enlace

    zoneTemp: null,
    zoneDelete: null,
    typeResource: '',

    srcResource: '',//Recurso interactivo que se desea abrir
    ocultarBarra: false,//Oculta las opciones que estan en la esquina superior derecha cuando se abre una herramienta como los de hacer trazos en el canvas
    zoneID: service.idZone,
    indexLM: 0,//LM selecionado
    index: 0,//Indice de la pagina del LM
    escala: 1.0,//Escala del zoom,
    
    srcAudio: null,
    srcVideo: null,
    widthAudioVideoModal: '',
    transparente: '', //Valida si es que se escogio la opcion de transparente
    loading: false,
    scale3d: 1,
  },

  /**
   * Esta funciones seran accedidas por cualquier componente creado
   * Solo poner funciones que se repiten varias veces en los componentes
   */
  mutations: {
    resizeWindow(state){
      console.log("REDIMENSIONAR")
      state.loading = false;
      $('.btnPaginationLeft').addClass('isInactiveCanvas');
      $('.btnPaginationRight').addClass('isInactiveCanvas');
      $(".inputPagination").prop('disabled', true);
      $("#btnPages").addClass('isInactiveCanvas');
      $(".contBtnUnits").addClass('isInactiveCanvas');
      $(".pestana").addClass('pestanaDesactivadaCanvas');
      $(".icon-zoom").addClass('isInactiveCanvas');
      // $(".icon-media ").addClass('isInactiveCanvas');

      new Promise((resolve, reject) => {
        let img = document.createElement('img');
        
        let carpetaLM = state.ebook[state.indexLM].carpeta;
        let existeImg = require("@/assets/img/paginas/" + carpetaLM +"/" + (state.index + 1) + ".jpg");
        
        img.src= existeImg;
        img.onload = resolve();
        img.onerror = reject();
      })
      .then(() => {
        let img = new Image();
        
        let carpetaLM = state.ebook[state.indexLM].carpeta;
        let existeImg = require("@/assets/img/paginas/" + carpetaLM +"/" + (state.index + 1) + ".jpg");
        img.src= existeImg;
        
        img.onload = () => {
          
          if(img.height < 1500){
            state.scale3d = ($('#pageImgOne').height() / 1750).toFixed(3);
          } else{
            state.scale3d = ($('#pageImgOne').height() / img.height).toFixed(3);
          }
          
          var canvas = document.getElementById('canvasMain');
          var li = document.getElementById('pageLM');
          canvas.width = li.clientWidth;
          canvas.height = li.clientHeight;
          state.loading = true;
          $('.btnPaginationLeft').removeClass('isInactiveCanvas');
          $('.btnPaginationRight').removeClass('isInactiveCanvas');
          $(".inputPagination").prop('disabled', false);
          $("#btnPages").removeClass('isInactiveCanvas');
          $(".contBtnUnits").removeClass('isInactiveCanvas');
          $(".pestana").removeClass('pestanaDesactivadaCanvas');
          $(".icon-zoom").removeClass('isInactiveCanvas');
          // $(".icon-media ").removeClass('isInactiveCanvas');
        }
        
      })
      .catch((e)=>{
        console.log(e)
        console.log("ERROR IRLM")
      })
    },
    disabledAudio(state){
      if(state.config.disableAudioChangePage){
        state.srcAudio = null;
        state.modalAudio = false;
      }
    },

    /**
     * Se va a la siguiente pagina cada vez que presione el boton siguiente
     */
    siguiente(state){
      let viewer = document.getElementById('viewer')

      //Si la pagina esta al principio y en doble, entonces se remueve el single
      if(state.index <= 0 && state.twoPages){
        viewer.classList.remove('single');
        state.index ++;
      } else if(state.index <= state.ebook[state.indexLM].paginas.length - 2) {
         
        //Si la pagina esta en doble
        if(state.twoPages) {

          //Pasa de 2 en 2 en las paginas
          state.index += 2;

          //Si se esta en la ultima pagina, entonces se agrega el single
          if(state.index == state.ebook[state.indexLM].paginas.length - 1){
            viewer.classList.add('single');
          } else if (state.index == state.ebook[state.indexLM].paginas.length) {
            state.index -=2;
          }
        } else {
          state.index ++;
        }
      }

      this.commit('disabledAudio');

      this.commit('limites', state.twoPages);
      this.commit('resetearCanvas');
    },

    /**
     * Se va a la atras pagina cada vez que presione el boton atras
     */
    atras(state){     
      let viewer = document.getElementById('viewer')

      //Si la pagina se posiciona en la ultima pagina
      if(state.index == state.ebook[state.indexLM].paginas.length - 1) {

        //Si es doble, se remueve el single page
        if(state.twoPages){
          viewer.classList.remove('single');
        }
        state.index-= 2;

        //Si se dirige a la primera pagina
      } else if(state.index == 1) {
        viewer.classList.add('single');
        state.index--;
      } else if(state.index == 0){
        this.commit('limites', state.twoPages);
        return
      }else {
        if(state.twoPages) {
          state.index -= 2;
        } else {
          state.index--;
        }
        
        this.commit('resetearCanvas');
      }
      this.commit('disabledAudio');
      this.commit('limites', state.twoPages);
    },
    openModalAudioVideo(state, payload){ 
      state.srcAudio = null;
      state.srcVideo = null;
      switch(payload.tipo){
        case "video":
          
          state.srcVideo = "recursos/VIDEOS/"+payload.recurso + ".mp4";
          state.widthAudioVideoModal = "250px";
          break;
        case "audio":
          
          state.srcAudio = "recursos/AUDIOS/"+payload.recurso + ".mp3";
          state.widthAudioVideoModal = "220px";
          break;
      }
      if(payload.mode != null && payload.mode != "small"){
        state.modalAudio = true;
      }
      
    },
    addZoneActive(state, payload){
      //Cuando no existe ninguna zona activa agregada
      if(state.zonasActivas[state.indexLM][payload.page] == null){
        Vue.set(state.zonasActivas[state.indexLM], payload.page, new Array(0));
      }

      Vue.set(state.zonasActivas[state.indexLM][payload.page], state.zonasActivas[state.indexLM][payload.page].length, payload.data);
      state.service.setIDZone(state.zoneID);
      state.service.setZoneActive(state.zonasActivas);
      var pageImg = document.getElementsByClassName("zonaTransparente");
      pageImg[0].hidden = true;
      pageImg[1].hidden = true;
    },
    updateZoneActive(state, id){
      for(let i = 0; i < state.ebook.length; i++) {
        if (state.zonasActivas[i] != null) {
          
          for (let key in  state.zonasActivas[i]) {
            let value = state.zonasActivas[i][key];
      
            for (let j = 0; j < value.length; j++) {
              if(value[j]["id"] && id == value[j]["id"]){
                Vue.set(value, j, state.zoneDelete)
                state.zoneDelete = null;
                state.service.setZoneActive(state.zonasActivas);
                return;
              }
            }
          }
        }
      } 
    },
    deleteZoneActive(state, id){
      for(let i = 0; i < state.ebook.length; i++) {
        if (state.zonasActivas[i] != null) {
          
          for (let key in  state.zonasActivas[i]) {
            let value = state.zonasActivas[i][key];
      
            for (let j = 0; j < value.length; j++) {
              if(value[j]["id"] && id == value[j]["id"]){
                let temp = value.slice(0,j).concat(value.slice(j + 1));
                Vue.set(state.zonasActivas[i], key, temp);
                state.zoneDelete = null;
                state.service.setZoneActive(state.zonasActivas);
                return;
              }
            }
          }
        }
      } 
    },
    findZoneActive(state, id){
      for(let i = 0; i < state.ebook.length; i++) {
        if (state.zonasActivas[i] != null) {
          
          for (let key in  state.zonasActivas[i]) {
            let value = state.zonasActivas[i][key];
      
            for (let j = 0; j < value.length; j++) {
              if(id == value[j]["id"]){
                return value[j];
              }
            }
          }
        }
      } 
      return null
    },
    setCropper(state, isCrop){
      state.isCrop = isCrop;
    },
    setTypeResource(state, type){
      state.typeResource = type
    },
    setZoneDelete(state, zoneDelete){
      state.zoneDelete = zoneDelete
    },
    setZoneActiveTrans(state, zone){
      let page = zone.page;
      let posX = ((zone.x / state.escala)).toFixed(3);
      let posY = ((zone.y / state.escala)).toFixed(3);
      let width = (zone.width).toFixed(3) + "px";
      let height = (zone.height).toFixed(3) + "px";
      let id = JSON.parse(JSON.stringify(state));
      state.zoneID++;
      state.zoneTemp = {data: {"id":id.zoneID,"x": posX, "y":posY, "width": width, "height": height, "transparente": true}, "page": page}
    },
    setZoneActive(state, zone){
      let page = 'pag_' + zone.target.getAttribute('data-page');
      let posX = (((zone.pageX - zone.target.getBoundingClientRect().x) / state.escala) * (1 / zone.scale3d)).toFixed(3) - 50;
      let posY = (((zone.pageY - zone.target.getBoundingClientRect().y) / state.escala) * (1 / zone.scale3d)).toFixed(3) - 50;
      let id = JSON.parse(JSON.stringify(state));
      state.zoneID++;
      state.zoneTemp = {data: {"id":id.zoneID,"x": posX, "y":posY, "transparente": false}, "page": page}
    },
    setMobile(state){
      let eventWidth = () => {
        if(window.innerWidth < 900){
          state.isMobile = true;
          state.twoPages = false;
          return;
        }
        state.isMobile = false;
      }
      eventWidth();
      window.addEventListener('resize', ()=>{
        eventWidth();
      });
    },

    setTypeModalResource(state, type){
      state.typeModalResource = type
    },

    setTwoPages(state,isTwoPage){
      state.twoPages =isTwoPage;
    },

    /**
     * Busca la pagina que se ingreso en la caja de paginas o si se presiona el boton de unidades
     */
    buscarPagina(state, i){
      let viewer = document.getElementById('viewer')

      if(state.twoPages){
        viewer.classList.remove('single');
      }
      const find = (element) => element.toUpperCase() == i.toUpperCase();

      var i = state.ebook  [state.indexLM].paginas.findIndex(find)
      i = (i == -1)? 0 : i;
      if(state.twoPages && i % 2 == 0 && i != 0){
        i--;
      }
      if(i == 0){
        viewer.classList.add('single');
      }

      state.index = i;
      
      this.commit('limites', state.twoPages);
      this.commit('resetearCanvas');
    },

    buscarPaginaIndex(state, i){
      let viewer = document.getElementById('viewer')

      if(state.twoPages){
        viewer.classList.remove('single');
      }

      if(state.twoPages && i % 2 == 0 && i != 0){
        i--;
      }
      if(i == 0){
        viewer.classList.add('single');
      }

      state.index = i;
      
      this.commit('limites', state.twoPages);
      this.commit('resetearCanvas');
    },

    buscarLMUnidad(state, payload){
      if(payload.lm != null){
        state.indexLM = payload.lm
      } 
      
      if(payload.unitIndex != null){
        this.commit('buscarPaginaIndex', payload.unitIndex);
        
      } else {
        this.commit('buscarPagina', payload.unit);
      }
      this.commit('disabledAudio');
      this.commit('resizeWindow');
    },

    setModalCredits(state, isOpen){
      state.modal = isOpen;
      state.maxWidthModal = 1440;
      state.openCredits = isOpen;
    },

    setModalResourceFull(state, payload){
      if(payload.resource != null){
        state.srcResource = 'recursos/MULTIMEDIA/' + payload.resource;
      } else{
        state.srcResource = null;
      }
      
      state.openResourceFull = payload.isOpen;
      if(payload.isOpen){
        var $this = this;
        setTimeout(function(){
          $this.commit('resizeModalResource');
        }, 250);
      }
       
    },

    setModalResource(state, isOpen){
      state.modal = isOpen;
      state.maxWidthModal = 1440;
      state.openResource = isOpen;
    },

    setModalAddResource(state, isOpen){
      state.modal = isOpen;
      state.maxWidthModal = 370;
      state.openAddResource = isOpen;
    },

    setWidthModal(state, size){
      state.maxWidthModal = size;
    },

    resizeModalResource(){
      var nameId = 'resizeBody'
      var idContainter = document.getElementById(nameId);
      var scale = 0;
      var $this = this
      window.onresize = function(){
        if($this.state.openResourceFull){
          resizeApp();
        }
      }

      function resizeApp(){
        var winHeight = window.innerHeight;
        var winWidth = window.innerWidth;
        var appWidth = idContainter.offsetWidth;
          var appHeight = idContainter.offsetHeight ;

        winWidth = window.innerWidth; //retrieve current window width
        winHeight = window.innerHeight; //retrieve current window height

        //scale = ((appWidth/winWidth)<(appHeight/winHeight))?(appWidth/winWidth):(appHeight/winHeight);

        scale = ((winWidth/appWidth)<(winHeight/appHeight))?(winWidth/appWidth):(winHeight/appHeight);

        var ua = window.navigator.userAgent
          var msie = ua.indexOf( "MSIE " )

        if(msie>0){
          idContainter.style.zoom = scale;
        }else{
          document.getElementById(nameId).style.webkitTransformOrigin = '0 0';
          document.getElementById(nameId).style.webkitTransform = "scale("+scale+")";
          document.getElementById(nameId).style.MozTransformOrigin = '0 0';
          document.getElementById(nameId).style.MozTransform = "scale("+scale+")";
        }

        var appWidth = document.getElementById(nameId).offsetWidth * scale;
        document.getElementById(nameId).style.left = ((winWidth - appWidth )/2)+'px';

      }
      resizeApp();
    },

    /**
     * Limpia el canvas
     */
    resetearCanvas(){
      
      setTimeout(function () {
        var canvas1 = document.getElementById('canvasMain');
        canvas1.width = canvas1.width;
        $('#viewer').css('cursor','auto');
      }, 25);

    },

    /**
     * Se encarga de deshabilitar los botones siguiente y atras, de acuerdo en que posicion de la pagina este el usuario
     */
    limites(state, twoPages) {
      
      if (state.index == 0) {
        $('.btnPaginationLeft').addClass('isInactive');
        $('.btnPaginationRight').removeClass('isInactive');
      } else if (state.index == state.ebook[state.indexLM].paginas.length - 1) {
        $('.btnPaginationLeft').removeClass('isInactive');
        $('.btnPaginationRight').addClass('isInactive');
      } else if (twoPages && state.index == state.ebook[state.indexLM].paginas.length - 2){
        $('.btnPaginationLeft').removeClass('isInactive');
        $('.btnPaginationRight').addClass('isInactive');
      } else {
        $('.btnPaginationLeft').removeClass('isInactive');
        $('.btnPaginationRight').removeClass('isInactive');
      }
    },

    /**
     * Deshabilita la pestaña que esta seleccionada
     */
    correcionLM(state, i){
      for(let j = 0; j < state.ebook.length; j++){
        if(i == j){
          $('#pestanaLM' + j).addClass('pestanaDesactivada');
        } else {
          $('#pestanaLM' + j).removeClass('pestanaDesactivada');
        }
      }
      state.indexLM = i;//Cambia la posicion al LM que se selecciono
      $('.btnPaginationLeft').addClass('isInactive');
      $('.btnPaginationRight').removeClass('isInactive');
    },
    addActiveZone(type){

    }
  },
  actions: {
  },
  modules: {
  }
})
